'use strict';
import React, { Component } from 'react';
class ColumnTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderColumn: props.orderColumn
        }; 
        this.orderColumn = this.orderColumn.bind(this);
    }


    orderColumn() {
        this.state.orderColumn(this.props.columnIndex);
    }

    render() {
        return (
            <label>
                <span id="orderColumn" onClick={this.orderColumn}>{this.props.title}
                    {
                        this.props.order ?
                            this.props.icon ?
                                <i className="glyphicon glyphicon-triangle-bottom"></i> : < i className="glyphicon glyphicon-triangle-top" ></i >
                            : null
                    }
                </span>
            </label>
        );
    }
}

export default ColumnTitle